import { createSlice as createSliceRT, Selector, SliceCaseReducers } from '@reduxjs/toolkit';
import { factoryExtraSelectors } from 'helpers/slice';
import get from 'lodash/get';
import {
  CreateSliceArgs,
  CreateSliceReturn,
  CreateSliceReturnSelectors,
  MakerSelectors,
  RootState,
} from 'types';

export function createSlice<
  State,
  Reducers extends SliceCaseReducers<State>,
  MSelectors extends MakerSelectors<State> | undefined = undefined
>({
  nestedPath = [],
  name,
  extraSelectors,
  initialState,
  reducers,
  extraReducers,
}: CreateSliceArgs<State, Reducers, MSelectors>): CreateSliceReturn<State, Reducers, MSelectors> {
  const prefix = [...nestedPath, name].join('.');

  const { actions, reducer } = createSliceRT<State, Reducers>({
    name: prefix,
    initialState,
    reducers,
    extraReducers,
  });

  const getState: Selector<RootState, State> = (rootState) => get(rootState, prefix) as State;

  const customSelectors = factoryExtraSelectors<State, MSelectors>(getState, extraSelectors);

  const allSelectors = {
    getState,
    ...(customSelectors || {}),
  } as CreateSliceReturnSelectors<State, MSelectors>;

  return {
    reducer: { [name]: reducer },
    name,
    selectors: allSelectors,
    actions,
  };
}
